import {
  BarChartOutlined,
  InboxOutlined,
  MoneyCollectOutlined,
  ProfileOutlined,
  ReadOutlined,
  SettingOutlined,
  TeamOutlined
} from '@ant-design/icons'

import { EaAuctionIcon } from '@eastcoal/icon/EaAuctionIcon'
import { RouteItem } from '@eastcoal/router/types/route'

import { ConsoleLayout } from '../layouts/ConsoleLayout'
import { UserLayout } from '../layouts/UserLayout'
import { applyAnnouncementRoute } from '../pages/Content/Announcement/Apply/route'
import { transactionAnnouncementRoute } from '../pages/Content/Announcement/Transaction/route'
import { helpDocRoute } from '../pages/Content/HelpDoc/route'
import { newsRoute } from '../pages/Content/News/route'
import { noticeRoute } from '../pages/Content/Notice/route'
import { supplyDemandRoute } from '../pages/Content/SupplyDemand/route'
import { accountStatementRoute } from '../pages/Data/AccountStatement/route'
import { abnormalBidRecordRoute } from '../pages/Data/BidRecord/AbnormalRecord/route'
import { costStatisticsRoute } from '../pages/Data/CostStatistics/route'
import { employeePerformanceRoute } from '../pages/Data/EmployeePerformance/route'
import { hbcoalSalePlanRoute } from '../pages/Data/HBCoalSalePlan/route'
import { platformFeeRoute } from '../pages/Data/PlatformFee/route'
import { platformTradeVolumeRoute } from '../pages/Data/PltformTradeVolume/route'
import { priceIndexRoute } from '../pages/Data/PriceIndex/route'
import { tradeOrderRoute } from '../pages/Data/TradeOrder/route'
import { tradeSessionRoute } from '../pages/Data/TradeSession/route'
import { debuggerRoute } from '../pages/Debugger/route'
import { accountJournalRoute } from '../pages/Finance/AccountJournal/route'
import { internalCollectionRoute } from '../pages/Finance/InternalCollection/route'
import { rechargeApplyRoute } from '../pages/Finance/RechargeApply/route'
import { unfreezeApplyRoute } from '../pages/Finance/UnfreezeApply/route'
import { withdrawApplyRoute } from '../pages/Finance/WithdrawApply/route'
import { homeRoute } from '../pages/Home/route'
import { listingListRoute } from '../pages/Listing/List/route'
import { memberAuditEnterpriseRoute } from '../pages/Member/AuditEnterprise/route'
import { memberAuditPersonRoute } from '../pages/Member/AuditPerson/route'
import { auditSuccessRoute } from '../pages/Member/AuditSuccess/route'
import { memberAuthenticationRoute } from '../pages/Member/Authentication/route'
import { blacklistRoute } from '../pages/Member/Blacklist/route'
import { memberDetailRoute } from '../pages/Member/MemberDetail/route'
import { memberGroupRoute } from '../pages/Member/MemberGroup/route'
import { allMemberRoute } from '../pages/Member/MemberListAll/route'
import { myMemberRoute } from '../pages/Member/MemberListMy/route'
import { orderComplaintRoute } from '../pages/Order/Complaint/route'
import { orderListRoute } from '../pages/Order/List/route'
import { orderRecordRoute } from '../pages/Order/Record/route'
import { areaRoute } from '../pages/System/Area/route'
import { dictRoute } from '../pages/System/Dict/route'
import { kindRoute } from '../pages/System/Kind/route'
import { bannerPCRoute } from '../pages/System/MallConfig/Banner/route'
import { brandRoute } from '../pages/System/MallConfig/Brand/route'
import { helpLinkRoute } from '../pages/System/MallConfig/HelpLink/route'
import { rankRoute } from '../pages/System/MallConfig/Rank/route'
import { memberDefaultResourceRoute } from '../pages/System/MemberResource/route'
import { mineRoute } from '../pages/System/Mine/route'
import { bannerMiniProgramRoute } from '../pages/System/MiniProgramConfig/Banner/route'
import { organizationRoute } from '../pages/System/Organization/route'
import { portRoute } from '../pages/System/Port/route'
import { pricingRoute } from '../pages/System/Pricing/route'
import { regionRoute } from '../pages/System/Region/route'
import { roleRoute } from '../pages/System/Role/route'
import { variableRoute } from '../pages/System/Template/Variable/route'
import { houseAuctionRoute } from '../pages/TradeSession/Auction/House/route'
import { inquiryAuctionRoute } from '../pages/TradeSession/Auction/Inquiry/route'
import { rankingAuctionRoute } from '../pages/TradeSession/Auction/Ranking/route'
import { secretAuctionRoute } from '../pages/TradeSession/Auction/Secret/route'
import { tenderAuctionRoute } from '../pages/TradeSession/Auction/Tender/route'
import { traditionAuctionRoute } from '../pages/TradeSession/Auction/Tradition/route'
import { priceCompareListRoute } from '../pages/TradeSession/PriceCompare/route'
import { tradeSessionPublishRoute } from '../pages/TradeSession/Publish/route'
import { yXSalePlanRoute } from '../pages/TradeSession/SalePlan/route'
import { loginRoute } from '../pages/User/Login/route'
import { passwordRoute } from '../pages/User/Password/route'
import { securityRoute } from '../pages/User/Security/route'

/**
 * 1. 布局配置
 * 2. 菜单层级配置
 */
export const routes: RouteItem[] = [
  {
    element: <UserLayout />,
    children: [loginRoute, passwordRoute]
  },
  {
    element: <ConsoleLayout />,
    children: [
      homeRoute,
      securityRoute,
      {
        title: '系统配置',
        icon: <SettingOutlined />,
        children: [
          organizationRoute,
          roleRoute,
          dictRoute,
          pricingRoute,
          regionRoute,
          areaRoute,
          portRoute,
          kindRoute,
          mineRoute,
          memberDefaultResourceRoute,
          {
            title: '合同模板',
            children: [variableRoute]
          },
          {
            title: '商城配置',
            children: [rankRoute, bannerPCRoute, brandRoute, helpLinkRoute]
          },
          {
            title: '小程序配置',
            children: [bannerMiniProgramRoute]
          }
        ]
      },
      {
        title: '会员管理',
        icon: <TeamOutlined />,
        children: [
          memberGroupRoute,
          myMemberRoute,
          allMemberRoute,
          memberAuthenticationRoute,
          memberDetailRoute,
          memberAuditEnterpriseRoute,
          memberAuditPersonRoute,
          auditSuccessRoute,
          blacklistRoute
        ]
      },
      {
        title: '内容管理',
        icon: <ReadOutlined />,
        children: [
          applyAnnouncementRoute,
          transactionAnnouncementRoute,
          supplyDemandRoute,
          newsRoute,
          helpDocRoute,
          noticeRoute
        ]
      },
      {
        title: '商品管理',
        icon: <InboxOutlined />,
        children: [listingListRoute]
      },
      {
        title: '竞价管理',
        icon: <EaAuctionIcon />,
        children: [
          tradeSessionPublishRoute,
          traditionAuctionRoute,
          rankingAuctionRoute,
          houseAuctionRoute,
          inquiryAuctionRoute,
          secretAuctionRoute,
          tenderAuctionRoute,
          priceCompareListRoute,
          yXSalePlanRoute
        ]
      },
      {
        title: '资金管理',
        icon: <MoneyCollectOutlined />,
        children: [
          rechargeApplyRoute,
          unfreezeApplyRoute,
          internalCollectionRoute,
          withdrawApplyRoute,
          accountJournalRoute
        ]
      },
      {
        title: '订单管理',
        icon: <ProfileOutlined />,
        children: [orderListRoute, orderRecordRoute, orderComplaintRoute]
      },
      {
        title: '数据统计',
        icon: <BarChartOutlined />,
        children: [
          priceIndexRoute,
          employeePerformanceRoute,
          platformTradeVolumeRoute,
          costStatisticsRoute,
          tradeOrderRoute,
          tradeSessionRoute,
          abnormalBidRecordRoute,
          platformFeeRoute,
          accountStatementRoute,
          hbcoalSalePlanRoute
        ]
      },
      debuggerRoute
    ]
  }
]
